import { fetchQuestion as fetchQuestionAPI } from "../api";

export const fetchQuestionAction = async (
  questionID,
  assignmentID,
  setQuestion,
  setHtml,
  user
) => {
  const question = await fetchQuestionAPI(questionID);
  setQuestion(question.data);
  let attempts = user.assignment_attempts;

  let foundAssignment = false;
  let foundQuestion = false;
  let i = 0;

  while (i < attempts.length && !foundAssignment) {
    let attempt = attempts[i];

    if (attempt.assignment === assignmentID) {
      foundAssignment = true;
      let j = 0;
      while (j < attempt.answers.length && !foundQuestion) {
        let answer_element = attempt.answers[j];
        if (answer_element.question === questionID) {
          foundQuestion = true;
          // found question attempt
          setHtml(answer_element.answer);
        }
        j++;
      }
      if (!foundQuestion) {
        // found assignment attempt but not for this question
        setHtml(question.data?.code);
      }
    }
    i++;
  }
  if (!foundAssignment) {
    // no previous assignment attempt found
    setHtml(question.data?.code);
  }
};

export const simpleFetchQuestion = async (questionID) => {
  const res = await fetchQuestionAPI(questionID);
  return res.data;
};
